/* eslint-disable typescript-extended-rules/file-naming-convention */
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import {
	BeneficiaryReconciliationApplyAction,
	BeneficiaryReconciliationItem,
} from '../../../../../modules/beneficiary-reconciliations/models/beneficiary-reconciliation.model';

interface BeneficiaryReconciliationHistoryDetailModalData {
	item: BeneficiaryReconciliationItem;
}

@Component({
	selector: 'app-beneficiary-reconciliation-history-detail-modal',
	styleUrls: [
		'./beneficiary-reconciliation-history-detail-modal.component.scss',
	],
	templateUrl:
		'./beneficiary-reconciliation-history-detail-modal.component.html',
})
export class BeneficiaryReconciliationHistoryDetailModalComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: BeneficiaryReconciliationHistoryDetailModalData,
		private readonly dialogRef: MatDialogRef<BeneficiaryReconciliationHistoryDetailModalComponent>,
	) {}

	get action(): string {
		const action = this.data.item.context?.resolution?.action;

		if (!action) {
			return '-';
		}

		return this.getApplyActionLabel(action);
	}

	get appliedAt(): string | null {
		return (
			this.data.item.context?.resolution?.appliedAt ??
			this.data.item.appliedAt ??
			null
		);
	}

	get appliedByName(): string {
		return (
			this.getStringValue(this.data.item.context?.resolution?.appliedByName) ||
			'-'
		);
	}

	get errorMessage(): string {
		return (
			this.getStringValue(this.data.item.errorMessage) ||
			this.getStringValue(this.data.item.context?.resolutionError) ||
			'-'
		);
	}

	get payloadFormatted(): string {
		return this.formatJson(this.data.item.context?.resolution?.payload);
	}

	formatJson(value: unknown): string {
		if (value === undefined || value === null) {
			return '-';
		}

		if (typeof value === 'string') {
			return value.trim() || '-';
		}

		try {
			return JSON.stringify(value, null, 2);
		} catch (error) {
			return String(value);
		}
	}

	onClose(): void {
		this.dialogRef.close();
	}

	private getApplyActionLabel(
		action: BeneficiaryReconciliationApplyAction,
	): string {
		switch (action) {
			case 'CREATE_BENEFICIARY':
				return 'Criar beneficiário';
			case 'IGNORE_ITEM':
				return 'Ignorar item';
			case 'INACTIVATE_BENEFICIARY':
				return 'Inativar beneficiário';
			case 'LINK_EXISTING_BENEFICIARY':
				return 'Vincular beneficiário existente';
			case 'REACTIVATE_BENEFICIARY':
				return 'Reativar beneficiário';
			case 'SELECT_DUPLICATE_ROW':
				return 'Selecionar linha duplicada';
			case 'TRANSFER_ORGANIZATION':
				return 'Transferir organização';
			case 'UPDATE_CARD':
				return 'Atualizar carteirinha';
			case 'UPDATE_PLAN':
				return 'Atualizar plano';
			case 'UPDATE_PLAN_AND_CARD':
				return 'Atualizar plano e carteirinha';
			case 'UPDATE_TITULARITY':
				return 'Atualizar titularidade';
			default:
				return action;
		}
	}

	private getStringValue(value: unknown): string {
		if (typeof value !== 'string') {
			return '';
		}

		return value.trim();
	}
}
